export default {
  about_us: 'ABOUT US',
  services: 'SERVICES',
  solutions: 'Solutions',
  blog: 'BLOG',
  portfolio: 'PORTFOLIO',
  contact: 'CONTACT',
  footerMessage: 'Apok, C.A J-40065605-2 |   All rights reserved 2019',
  home: 'HOME',
  notFound: 'The page you are looking for cannot be found.',
  goHome: 'Go Home',
}



// WEBPACK FOOTER //
// ./src/i18n/en/home.js